export class ApiError extends Error {
  constructor(message: string, public status: number, public code?: string) {
    super(message);
  }
}
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: "include",
    ...init,
    headers: init?.body ? { "Content-Type": "application/json", ...init.headers } : init?.headers,
  });
  const data = await response.json().catch(() => ({ ok: false, error: "Invalid server response" })) as {
    ok?: boolean; error?: string; code?: string;
  };
  if (!response.ok || data.ok === false) throw new ApiError(data.error || "Request failed", response.status, data.code);
  return data as T;
}
export const post = <T>(path: string, value: unknown) => api<T>(path, { method: "POST", body: JSON.stringify(value) });
export const put = <T>(path: string, value: unknown) => api<T>(path, { method: "PUT", body: JSON.stringify(value) });
export const patch = <T>(path: string, value: unknown) => api<T>(path, { method: "PATCH", body: JSON.stringify(value) });export const remove = <T>(path: string, value: unknown) => api<T>(path, { method: "DELETE", body: JSON.stringify(value) });

